function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5404 12.3404C11.6623 12.2185 11.8276 12.15 12 12.15C12.1724 12.15 12.3377 12.2185 12.4596 12.3404C12.5815 12.4623 12.65 12.6276 12.65 12.8V17.6C12.65 17.7724 12.5815 17.9377 12.4596 18.0596C12.3377 18.1815 12.1724 18.25 12 18.25C11.8276 18.25 11.6623 18.1815 11.5404 18.0596C11.4185 17.9377 11.35 17.7724 11.35 17.6V12.8C11.35 12.6276 11.4185 12.4623 11.5404 12.3404Z",
  fill: "#6B6B6B",
  stroke: "#333333",
  strokeWidth: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.74998 9.60005C5.74998 9.42766 5.81846 9.26233 5.94036 9.14043C6.06225 9.01853 6.22758 8.95005 6.39998 8.95005C6.57237 8.95005 6.7377 9.01853 6.85959 9.14043C6.98149 9.26233 7.04998 9.42766 7.04998 9.60005V17.6C7.04998 17.7724 6.98149 17.9378 6.85959 18.0597C6.7377 18.1816 6.57237 18.25 6.39998 18.25C6.22758 18.25 6.06225 18.1816 5.94036 18.0597C5.81846 17.9378 5.74998 17.7724 5.74998 17.6V9.60005Z",
  fill: "#6B6B6B",
  stroke: "#333333",
  strokeWidth: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1404 5.94048C17.2623 5.81858 17.4276 5.7501 17.6 5.7501C17.7724 5.7501 17.9377 5.81858 18.0596 5.94048C18.1815 6.06238 18.25 6.22771 18.25 6.4001V17.6001C18.25 17.7725 18.1815 17.9378 18.0596 18.0597C17.9377 18.1816 17.7724 18.2501 17.6 18.2501C17.4276 18.2501 17.2623 18.1816 17.1404 18.0597C17.0185 17.9378 16.95 17.7725 16.95 17.6001V6.4001C16.95 6.22771 17.0185 6.06238 17.1404 5.94048Z",
  fill: "#6B6B6B",
  stroke: "#333333",
  strokeWidth: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.949988 4.00005C0.949988 3.19114 1.27133 2.41536 1.84331 1.84337C2.4153 1.27139 3.19108 0.950049 3.99999 0.950049H20C20.8089 0.950049 21.5847 1.27139 22.1567 1.84337C22.7286 2.41536 23.05 3.19114 23.05 4.00005V20C23.05 20.809 22.7286 21.5847 22.1567 22.1567C21.5847 22.7287 20.8089 23.0501 20 23.0501H3.99999C3.19108 23.0501 2.4153 22.7287 1.84331 22.1567C1.27133 21.5847 0.949988 20.809 0.949988 20V4.00005ZM2.24999 4.00005V20C2.24999 20.4642 2.43436 20.9093 2.76255 21.2375C3.09074 21.5657 3.53586 21.75 3.99999 21.75H20C20.4641 21.75 20.9092 21.5657 21.2374 21.2375C21.5656 20.9093 21.75 20.4642 21.75 20V4.00005C21.75 3.53592 21.5656 3.0908 21.2374 2.76261C20.9092 2.43442 20.4641 2.25005 20 2.25005H3.99999C3.53586 2.25005 3.09074 2.43442 2.76255 2.76261C2.43436 3.0908 2.24999 3.53592 2.24999 4.00005Z",
  fill: "#6B6B6B",
  stroke: "#333333",
  strokeWidth: 0.2
});

var SvgEvaluateArtist = function SvgEvaluateArtist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvaluateArtist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/evaluate-artist.16b1b368.svg";
export { ForwardRef as ReactComponent };